/* eslint-disable no-undef */
function encodeQueryData(data = null) {
  if (data) {
    const ret = [];
    for (let d in data) {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    }
    return '?' + ret.join('&');
  }
  return '';
}
const APIURL = process.env.REACT_APP_BACKEND_URL;
const apiClient = {
  Urls: {
    baseUrl: `${APIURL}/api`,
    serverUrl: process.env.REACT_APP_SERVER_URL,
    login: `${APIURL}/api/apilogin`,
    getUserInfo: `${APIURL}/api/info`,
    getOperationlHoursInfo: `${APIURL}/api/info/operational-hours`,
    getGroupsInfo: `${APIURL}/api/info/groups`,
    remoteAuth: `${APIURL}/api/auth/remote`,
    deviceAuth: `${APIURL}/api/auth/device`,
    requestCode: `${APIURL}/api/auth/request-code`
  },

  make: function (url, method, params, extraHeaders) {
    let headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'POST',
      'Access-Control-Allow-Headers': 'Content-Type, Authorization',
      'Access-Control-Allow-Credentials': 'true',
      ...extraHeaders
    };

    if (method == 'GET') {
      let queryParams = '';
      if (Object.keys(params || {}).length) {
        queryParams = encodeQueryData(params);
      }
      return fetch(url + queryParams, {
        method,
        headers
      })
        .then((response) => response.json())
        .catch((e) => e);
    } else {
      return fetch(url, {
        method,
        headers,
        body: JSON.stringify(params)
      })
        .then((response) => response.json())
        .catch((e) => e);
    }
  },

  authRequest: function (url, method, token) {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    myHeaders.append('Authorization', `Bearer ${token}`);
    var requestOptions = {
      method: method,
      headers: myHeaders,
      body: null,
      redirect: 'follow'
    };
    return fetch(url, requestOptions).then((response) => {
      if (response.ok === false) {
        throw Error(`Response ended with ${response.status}`);
      }
      return response.json();
    });
  },
  request: function (url, method, params, headers) {
    return apiClient.make(url, method, params, headers);
  },

  get: function (url, params, bearerToken) {
    let headers = {};
    if (bearerToken) {
      headers = {
        Authorization: `Bearer ${bearerToken}`
      };
    }
    return apiClient.make(url, 'GET', params, headers);
  },

  post: function (url, params, bearerToken) {
    let headers = {};
    if (bearerToken) {
      headers = {
        Authorization: `Bearer ${bearerToken}`
      };
    }
    return apiClient.make(url, 'POST', params, headers);
  },

  patch: function (url, params, bearerToken) {
    let headers = {};
    if (bearerToken) {
      headers = {
        Authorization: `Bearer ${bearerToken}`
      };
    }
    return apiClient.make(url, 'PATCH', params, headers);
  },

  delete: function (url, params, bearerToken) {
    let headers = {};
    if (bearerToken) {
      headers = {
        Authorization: `Bearer ${bearerToken}`
      };
    }
    return apiClient.make(url, 'DELETE', params, headers);
  }
};

export default apiClient;
